import { render, staticRenderFns } from "./PracticeCompareSheetList.vue?vue&type=template&id=1d71f4eb&"
import script from "./PracticeCompareSheetList.vue?vue&type=script&lang=ts&"
export * from "./PracticeCompareSheetList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports